import { useEffect, useState } from "react";
import api, { mediaUrl } from "@/lib/api";
import Reveal from "@/components/Reveal";
import GoldParticles from "@/components/GoldParticles";

const SPANS = ["sm:row-span-2 aspect-[3/4]", "aspect-[4/3]", "aspect-[4/3]", "sm:row-span-2 aspect-[3/4]", "aspect-[4/3]"];

export default function Gallery() {
  const [items, setItems] = useState([]);

  useEffect(() => {
    api.get("/gallery").then((r) => setItems(r.data)).catch(() => {});
  }, []);

  return (
    <div data-testid="gallery-page">
      <section className="relative overflow-hidden border-b border-white/5 py-24 sm:py-28">
        <GoldParticles density={30} />
        <div className="relative z-10 mx-auto max-w-7xl px-5 sm:px-8">
          <Reveal>
            <p className="eyebrow mb-5">The Gallery</p>
            <h1 data-testid="gallery-heading" className="max-w-3xl font-display text-4xl sm:text-5xl lg:text-6xl font-black leading-[1.05] tracking-tight text-[#F6F4EE]">
              Scenes from<br />
              <span className="text-gold-sheen">Inside the House.</span>
            </h1>
            <p className="mt-7 max-w-2xl text-sm sm:text-base leading-relaxed text-[#A19E95]">
              Candlelight, felt tables and war-room deliberations — the atmosphere of FINATEX, framed.
            </p>
          </Reveal>
        </div>
      </section>

      <section className="mx-auto max-w-7xl px-5 sm:px-8 py-20 sm:py-24">
        <div className="grid gap-5 sm:grid-cols-2 lg:grid-cols-3" data-testid="gallery-grid">
          {items.map((item, i) => (
            <Reveal key={item.id} delay={(i % 3) * 0.07} className={SPANS[i % SPANS.length].split(" ")[0] || ""}>
              <figure
                data-testid={`gallery-item-${i}`}
                className={`group relative h-full w-full overflow-hidden border border-white/8 ${SPANS[i % SPANS.length]}`}
              >
                <img
                  src={mediaUrl(item)}
                  alt={item.title}
                  loading="lazy"
                  className="h-full w-full object-cover transition-transform duration-700 ease-out group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-[#08080A]/90 via-transparent to-transparent opacity-80 transition-opacity duration-500 group-hover:opacity-100" />
                <figcaption className="absolute bottom-0 left-0 right-0 p-6">
                  <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-[#D4AF37]">{item.category}</p>
                  <p className="mt-2 font-display text-lg font-semibold text-[#F6F4EE]">{item.title}</p>
                </figcaption>
              </figure>
            </Reveal>
          ))}
        </div>
      </section>
    </div>
  );
}
